/***
 * 创建人：张丽莉
 * 时间：2019-06-11
 * 描述: 自定义导出列
 * 使用说明: 
 * 更新说明:
 */
import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
declare var $: any;
@Component({
  selector: 'sw-export-column',
  templateUrl: './sw-export-column.component.html',
  styleUrls: ['./sw-export-column.component.css']
})
export class SwExportColumnComponent implements OnInit, AfterViewInit {
  @Input() tableMenu: any = []; //表头数据 
  @Input() datas: any = []; //表数据
  @Input() id: string = ''; ////为父组件传入的id的key键
  dataColunm: any = [];//存放行的字段值，用于判断一行是否全选
  selectValue: any = {};
  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit() {
  }

  //获取Datas的key值 
  dataColunmInt(tableMenu) {
    this.dataColunm = []
    tableMenu.forEach(element => {
      this.dataColunm.push(element.name)
    });
  }

  //点击每行的全选按钮 触发该事件
  clickRowAll(event, data, index) {
    let targetChecked = event.target.checked;
    //清空
    this.selectValue[data[this.id]] = [];
    if (targetChecked) {
      this.dataColunm.forEach(element => {
        this.selectValue[data[this.id]].push(element)
      });
      //this.selectValue[data.CulId] = this.DataColunm;
      $("#id" + index + " input[type='checkbox']").prop("checked", true);
    } else {
      $("#id" + index + " input[type='checkbox']").prop("checked", false);
    }
    //判断全部行的列是否都选 如果为全选  则表头菜单的每一列全选  
    let colNum = 0;
    this.datas.forEach(val => {
      let col = this.selectValue[val[this.id]];
      if (col.length == this.dataColunm.length) {
        colNum++
      }
    })
    if (colNum == this.datas.length) {
      $("#tableTitle input[type='checkbox']").prop("checked", true);
    } else {
      $("#tableTitle input[type='checkbox']").prop("checked", false);
    }
  }

  //初始选择数据的每一项为空数组
  selectValueInit(datas) {
    datas.forEach(val => {
      this.selectValue[val[this.id]] = [];
    })
  }

  //全选
  clickRowColAll(event) {
    let target = event.target.checked;
    //全选
    if (target) {
      this.datas.forEach(val => {
        this.selectValue[val[this.id]] = [];
        this.dataColunm.forEach(ele => {
          this.selectValue[val[this.id]].push(ele)
        });
      })
      $("#tableTitle input[type='checkbox']").prop("checked", true);
      $(".tableBody input[type='checkbox']").prop("checked", true);
    } else {
      //全不选
      this.datas.forEach(val => {
        this.selectValue[val[this.id]] = [];
      })
      $("#tableTitle input[type='checkbox']").prop("checked", false);
      $(".tableBody input[type='checkbox']").prop("checked", false);
    }
  }

  //点击列中的checkbox 触发该事件
  clickColumn(event, data, index) {
    let targetChecked = event.target.checked;
    let targetValue = event.target.value;
    let selectArr = this.selectValue[data[this.id]];
    // this.selectValue[data.CulId].forEach(ele => {
    //   selectArr.push(ele)
    // });
    //如果选择为true
    if (targetChecked) {
      selectArr.push(targetValue)
    } else {
      //如果选择为false
      selectArr.forEach((val, index) => {
        if (val == targetValue) {
          selectArr.splice(index, 1)
        }
      });
    }
    //将selectArr在赋值给对应的selectValue
    this.selectValue[data[this.id]] = []
    selectArr.forEach(element => {
      this.selectValue[data[this.id]].push(element)
    });
    // this.selectValue[data.CulId] = selectArr;
    //当选择列时 判断表头菜单对应的列是否为全部选择
    let num = 0;
    this.datas.forEach(val => {
      let arr = this.selectValue[val[this.id]]
      if (arr.indexOf(targetValue) === -1) {
        num++
      }
    })
    //为对应列全选
    if (num == 0) {
      $("#tableTitle input[value='" + targetValue + "']").prop("checked", true);
    } else {
      $("#tableTitle input[value='" + targetValue + "']").prop("checked", false);
    }
    //对应行全选
    if (selectArr.length == this.dataColunm.length) {
      $("#id" + index + " input[type='checkbox']").eq(0).prop("checked", true);
    } else {
      $("#id" + index + " input[type='checkbox']").eq(0).prop("checked", false);
    }
    //判断全部行的列是否都选 如果为全选  则表头菜单的全选为true  
    let colNum = 0;
    this.datas.forEach(val => {
      let col = this.selectValue[val[this.id]];
      if (col.length == this.dataColunm.length) {
        colNum++
      }
    })
    if (colNum == this.datas.length) {
      $("#tableTitle input[type='checkbox']").eq(0).prop("checked", true);
    } else {
      $("#tableTitle input[type='checkbox']").eq(0).prop("checked", false);
    }
  }

  //点击表头列checkbox 触发该事件
  clickTableMenu(event) {
    let targetChecked = event.target.checked;
    let targetValue = event.target.value;
    //对应列和表头列选中的状态一致
    $(".tableBody input[value='" + targetValue + "']").prop("checked", targetChecked);
    //如果为选中
    if (targetChecked) {
      this.datas.forEach(val => {
        let arr = this.selectValue[val[this.id]]
        if (arr.indexOf(targetValue) === -1) {
          arr.push(targetValue)
        }
        this.selectValue[val[this.id]] = arr;
      })

    } else {
      //如果为非选中状态
      this.datas.forEach(val => {
        let arr = this.selectValue[val[this.id]]
        arr.forEach((element, index) => {
          if (element == targetValue) {
            arr.splice(index, 1)
          }
        });
        this.selectValue[val[this.id]] = arr;
      })
    }
    //判断行全选和总全选的状态
    let num = 0;
    this.datas.forEach((val, index) => {
      let arr = this.selectValue[val[this.id]]
      if (arr.length == this.dataColunm.length) {
        num++
        $("#id" + index + " input[type='checkbox']").eq(0).prop("checked", true);
      } else {
        $("#id" + index + " input[type='checkbox']").eq(0).prop("checked", false);
      }
    })
    if (num == this.datas.length) {
      $("#tableTitle input[type='checkbox']").eq(0).prop("checked", true);
    } else {
      $("#tableTitle input[type='checkbox']").eq(0).prop("checked", false);
    }
  }
  
  //格式化导出值
  getData() {
    let param = []
    this.datas.forEach(val => {
      let obj = { id: '', fieldName: '' };
      let arr = this.selectValue[val[this.id]]
      if (arr.length > 0) {
        obj.id = val[this.id];
        obj.fieldName = arr.join(',');
        param.push(obj)
      }
    })
    return param
  }


}
